<template>
  <div id="footer" class="container-fluid">
    <div class="logo">
      <img src="@/assets/img/logo_white.png"  class="i" alt="logo图">
    </div>
    <p class="title">南京讯石数据科技有限公司</p>
    <p class="address_tel_fax">
      <span>地址：南京市玄武区玄武大道699-1号7层710</span>
      <span>&emsp;</span>
      <span>Tel：180-617-517-75</span>
    </p>
    <p class="email_wx">
      <span>邮箱：inssec@inssec.cn</span>
    </p>
    <p class="email_wx">
      <span>许可证编号：<a href="https://beian.miit.gov.cn/" target="_blank">苏ICP备20001314号-1</a></span>
    </p>
    <p class="copy">Copyright &copy; 2018 - 2020 </p>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #474747;
  overflow: hidden;
  text-align: center;
}
.logo {
  width: 266.4px;
  margin: 50px auto 20px;
  -webkit-filter: grayscale(1);/* Webkit */ 
  filter:gray;/* IE6-9 */ 
  filter: grayscale(1);/* W3C */ 
}
.i {
  width: 100%;
  height: 100%;
  margin: 50px auto 20px;
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}
.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0 10px;
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {

  font-size: 12px;
}
.copy {
  font-size: 12px;
  margin: 30px 0 10px;
}
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue